function ColorColumn({ color }) {
  return <div style={{ color: color }}>{color}</div>;
}

export default ColorColumn;
